import { Controparte } from '../controparte';
import { DocumentoAggregato } from '../documento-aggregato';
import { Sezione } from './sezione';

export class SezioneControparti extends Sezione {
  controparti: Controparte[] = [];
  documentiAggregati: DocumentoAggregato[];
}
